import SolutionDeviceExtResources from './SolutionDeviceExtResources';

export default SolutionDeviceExtResources;
